import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import './Header.css';

export function Layout() {
    // TimeOverlay is now shown from App.tsx when isTimeUp() is true
    // No need to check here - App.tsx handles the routing
    return (
        <div className="app-shell">
            <Header />
            <main className="app-shell__main"><Outlet /></main>
        </div>
    );
}
